function sizeGuide() {
  const sizeGuideBtn = document.querySelector('.size-guide__button');
  const sizeGuideDrawerWrapper = document.querySelector(
    '.size-guide__drawer-wrapper',
  );
  const sizeGuideDrawer = sizeGuideDrawerWrapper?.querySelector(
    '.size-guide__drawer',
  );
  const sizeGuideCloseBtn = sizeGuideDrawerWrapper?.querySelector(
    '.size-guide__drawer__close-button',
  );

  // relocate size guide drawer
  sizeGuideDrawerWrapper &&
    document.body.insertAdjacentElement('afterbegin', sizeGuideDrawerWrapper);

  function toggleSizeGuideDrawer(drawer) {
    if (drawer.classList.contains('active')) {
      drawer.classList.remove('active');
    } else {
      drawer.classList.add('active');
    }
  }

  // open size guide drawer
  sizeGuideBtn?.addEventListener('click', () => {
    toggleSizeGuideDrawer(sizeGuideDrawerWrapper);
  });

  // close size guide drawer
  sizeGuideCloseBtn?.addEventListener('click', () => {
    toggleSizeGuideDrawer(sizeGuideDrawerWrapper);
  });

  // close size guide drawer when outside is clicked
  sizeGuideDrawerWrapper?.addEventListener('click', (e) => {
    if (e.target == sizeGuideDrawerWrapper) {
      toggleSizeGuideDrawer(sizeGuideDrawerWrapper);
    }
  });
}

export { sizeGuide as default };
